var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoCircleLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/video-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
    fill: "#2764FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.1992 24V21.04C18.1992 17.22 20.8992 15.68 24.1992 17.58L26.7592 19.06L29.3192 20.54C32.6192 22.44 32.6192 25.56 29.3192 27.46L26.7592 28.94L24.1992 30.42C20.8992 32.32 18.1992 30.76 18.1992 26.96V24Z",
    fill: "#2764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCircleLight);
export default __webpack_public_path__ + "static/media/video-circle-light.4c404c26b766f2165efffddc0ec682cc.svg";
export { ForwardRef as ReactComponent };